exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.styles--onlyXs__uSsxl{display:none !important}}@media (min-width: 768px){.styles--smUp__3st0q{display:none !important}}@media (max-width: 999px){.styles--mdDown__2TMXQ{display:none !important}}.styles--tabWrap__10rxV{margin-bottom:-1px}.styles--tabButton__3vPwk{font-size:16px;line-height:21px;font-weight:600;white-space:nowrap}@media (min-width: 768px){.styles--tabButton__3vPwk{font-size:18px;line-height:21px;font-weight:400}}\n", ""]);

// exports
exports.locals = {
	"onlyXs": "styles--onlyXs__uSsxl",
	"smUp": "styles--smUp__3st0q",
	"mdDown": "styles--mdDown__2TMXQ",
	"tabWrap": "styles--tabWrap__10rxV",
	"tabButton": "styles--tabButton__3vPwk"
};